import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import { Link as RouterLink } from 'react-router-dom';
import { LinkButton } from './LinkButton'
import { LoginLogoutButton } from './LoginButton';

import AuthSwitch from './AuthSwitch'
import ListIcon from '@material-ui/icons/List';
import NaturePeopleIcon from '@material-ui/icons/NaturePeople';
import ScheduleIcon from '@material-ui/icons/Schedule';

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
    color: theme.palette.type!=='dark'?'#000':'#FFF',
  },
  noDrawer: {
    background: theme.palette.type==='dark'?'#424242':'#FFF',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.type!=='dark'?'#000':'#FFF',
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.type!=='dark'?'#000':'#FFF',
    }
  }
}));



export default function ButtonAppBar(props) {
  const classes = useStyles();

  return <AppBar elevation={1} position="fixed" className={classes.noDrawer}>
      <Toolbar>
            <img
          src="/logo.png"
          width="30"
          height="30"
          //className="d-inline-block align-top"
          alt="React Bootstrap logo"
          />
        <Typography variant="h6" noWrap className={classes.title}>
          <RouterLink className={classes.link} to="/"> Dr. med. Rahel Pfister</RouterLink>
        </Typography>
        <AuthSwitch>
          <LinkButton activeColor="primary" responsive startIcon={<ListIcon/>} to="/admin/overview">Übersicht</LinkButton>
          <LinkButton activeColor="primary" responsive startIcon={<NaturePeopleIcon/>} to="/admin/vacation">Urlaub</LinkButton>
          <LinkButton activeColor="primary" responsive startIcon={<ScheduleIcon/>} to="/admin/openinghours">Öffnungszeiten</LinkButton>
        </AuthSwitch>
        <LoginLogoutButton />
      </Toolbar>
    </AppBar>
}